module.exports = __webpack_public_path__ + "static/img/banner2.4f3d8d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner2.jpg
// module id = UsdT
// module chunks = 26